export function upperCaseFirst(str) {
    return str ? str.replace(/^./, str[0].toUpperCase()) : str;
}

export const titleCase = (str) => {
    return (str) ? str.replace (/^[-_]*(.)/, (_, c) => c.toUpperCase())
        .replace (/[-_]+(.)/g, (_, c) => ' ' + c.toUpperCase()) : str;
}
